var map = {
	"./camera_mode_photo.svg": "49d4",
	"./camera_mode_video.svg": "fa52",
	"./cancel_takeoff_disabled.svg": "35b6",
	"./cancel_takeoff_enabled.svg": "a032",
	"./land.svg": "0f59",
	"./logo.svg": "9b19",
	"./mavic_2_480_60.jpg": "74d5",
	"./mavic_air_2_480_70.jpg": "5b30",
	"./mavic_mini_728_90.jpg": "061f",
	"./phantom_4_480_70.jpg": "9026",
	"./spark_468_60.jpg": "3679",
	"./takeoff.svg": "ae44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";